import React, { useContext, useEffect, useRef, useState } from "react";
import { ReferenciaPlantillaContenido } from "../../../../interfaces/ReferenciaPlantillaContenido";
import Button from "../../../atoms/button/button";
import Loading from "../../../atoms/loading/loading";
import MultipleSelectCards, { CardInterface } from "../../../molecules/multiple-select-cards/multipleSelectCards";
import MentoriaQuestionWizard from "../mentoria-question-wizard/mentoriaQuestionWizard";
import "./mentoriaPropositos.scss";
import GlobalContext from "../../../../contexts/globalContext";
import { getQuestionsByPurposes, getToken, postResponsesPurposes } from "../../../../services/mentoriaService";

interface MentoriaPropositosProps {
   cards: ReferenciaPlantillaContenido;
   setCurrentTab: any;
}

const HEADEROFFSET = 75;

const MentoriaPropositos = (props: MentoriaPropositosProps) => {
   const { cards } = props;
   const [selected, setSelected] = useState<Array<string>>([]);
   const [displayCards, setDisplayCards] = useState<Array<CardInterface>>([]);
   const [step, setStep] = useState(0);
   const [showQuestions, setShowQuestions] = useState<boolean>(false);
   const headerRef: any = useRef(null);
   const titleRef: any = useRef(null);
   const [propositosDataV2, setPropositosDataV2] = useState<any>([]);
   const [propositosQuestions, setPropositosQuestions] = useState<any>();
   const [loading, setLoading] = useState(false);
   const [questionsData, setQuestionsData] = useState<any>({})
   const context = useContext(GlobalContext);

   const handleSeleccionarPropositos = () => {
      setStep(step + 1);
   }

   const saveResponses = async () => {
      try {
         let token;
         if (context.gigyaContext.gigyaAccount) {
            token = await getToken(context.gigyaContext.gigyaAccount.UID);
         } else {
            return;
         }
         return await postResponsesPurposes(token.id_token, propositosDataV2);

      } catch (error) {
         console.error(error);
      } finally {
         props.setCurrentTab(1);
      }
   }

   const handlePropositosContinue = async () => {
      if (selected.length === 0) {
         // mensaje de error que no eligió ningún proposito
         return;
      }
      setLoading(true);
      try {

         if (context.gigyaContext.gigyaAccount) {
            const token = await getToken(context.gigyaContext.gigyaAccount.UID);

            getQuestionsByPurposes(JSON.stringify(selected), token.id_token).then((response: any) => {

               if (response.data.data.length === 0) {
                  setStep(step + 1);
                  return;
               }

               let questions: any = []

               response?.data?.data.forEach((purpose: any) => {
                  questions = [...questions, ...purpose.questions]
               });
               setPropositosQuestions(questions);
               setShowQuestions(true);
            }).catch((error) => {
               console.error(error);
               setShowQuestions(true);
               return;
            }).finally(() => {
               setLoading(false);
            })
         }
      } catch (error) {
         console.error(error);
         setLoading(false);
      }
   }

   const setDataV2 = (value, field, type: any = null) => {
      let dummie = {
         idQuestion: field,
         idOption: null,
         openResponse: "",
      };
      let questionPos = propositosDataV2.findIndex(
         (item) => item.idQuestion === field
      );
      let parsedValue;
      try {
         parsedValue = JSON.parse(value);
      } catch (error) {
         parsedValue = value;
      }
      if (parsedValue?.id) {
         dummie.idOption = parsedValue.id;
         dummie.openResponse = parsedValue.name;
      } else {
         dummie.openResponse = value;
      }
      let processed = [...propositosDataV2];
      if (type === "checkbox") {
         let exist = processed.findIndex(
            (question) =>
               question.idQuestion === field &&
               question.idOption === parsedValue.id
         );
         if (exist != -1) {
            // se filtra elemento por si ya existe
            processed.splice(exist, 1);
         } else {
            if (questionPos !== -1) {
               processed.splice(questionPos, 0, dummie)
            } else {
               processed.push(dummie);
            }
         }
      } else {
         if (questionPos !== -1) {
            processed[questionPos] = dummie;
         } else {
            processed.push(dummie);
         }
      }

      setPropositosDataV2(processed);
   };

   const setData = (value, field, type: any = null) => {
      setDataV2(value, field, type);

      let parsedValue;

      try {
         parsedValue = JSON.parse(value);
      } catch (error) {
         parsedValue = value;
      }

      const newFormData = { ...questionsData };
      if (!type) {
         newFormData[field] = parsedValue;
      } else if (type === "checkbox") {

         if (newFormData[field] === undefined) {
            newFormData[field] = [parsedValue];
         } else {
            const index = newFormData[field].findIndex((el) => el.id === parsedValue.id)
            if (index >= 0) {
               newFormData[field].splice(index, 1);
            } else newFormData[field] = [...newFormData[field], parsedValue];
         }
      }
      setQuestionsData(newFormData);
   }

   const nextFallback = () => {
      setShowQuestions(false);
      setStep(step + 1);
   }

   const prevFallback = () => {
      setShowQuestions(false);
   }

   const handlePropositosSave = () => {

      // Checkeo
      setStep(step + 1);
      headerRef?.current?.scrollIntoView();
   }

   useEffect(() => {
      if (step === 1) {
         if (titleRef && titleRef.current) {
            const y = titleRef.current.getBoundingClientRect().top + window.pageYOffset - HEADEROFFSET;
            window.scrollTo({
               top: y
            });
         }
      } else {
         if (headerRef && headerRef.current)
            headerRef.current.scrollIntoView();
      }
   }, [step, showQuestions])


   useEffect(() => {
      const newCards = cards.imagenPrincipal.map((card) => ({
         title: card.description,
         image: card.file.url,
         value: card.description,
      }));
      setDisplayCards(newCards);
   }, []);

   return (
      <div ref={titleRef} className="container">
         {(() => {

            if (showQuestions) {
               return null;
            }

            if (step === 0) {
               return (
                  <div className="mentoria-propositos-header__video-container">
                     <h3>¿Qué es un propósito?</h3>
                     <div className="mentoria-propositos-header__video-container__video">
                        <iframe
                           src="https://player.vimeo.com/video/718854601?h=a14e2697ea"
                           title="YouTube video player"
                           frameBorder="0"
                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                           allowFullScreen
                        />
                        {/* <iframe src="https://player.vimeo.com/video/718854601?h=a14e2697ea" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> */}
                     </div>
                  </div>
               );
            } else {
               return (
                  <div className="mentoria-propositos-header">
                     <div className="mentoria-propositos-header__head">
                        <h2>¿Cuáles son tus propósitos?</h2>
                        <span ref={headerRef} />
                     </div>
                     <div className="mentoria-propositos-header__body">
                        <img src={cards.imagenPrincipal[step].file.url} alt={cards.imagenPrincipal[step].description} />
                        <h3>{step === 1 ? 'Selecciona tus propósitos en el orden de prioridad para ti' : '¡La información de tus propósitos está lista!'}</h3>
                        <p>{step === 1 ? '' : 'Te invitamos a realizar tu diagnóstico.'}</p>
                     </div>
                     <div className="mentoria-propositos-header__divider"></div>
                  </div>
               );
            }
         })()
         }
         {loading &&
            <div className="mentoria-propositos__loading">
               <Loading />
            </div>}
         {(() => {
            switch (step) {
               case 0:
                  return (
                     <div className="mentoria-propositos-container">
                        {/* <Rating value="" onChange={() => { }} size={3} id="" name=""></Rating> */}
                        <img
                           src={cards.imagenPrincipal[0].file.url}
                           alt={cards.imagenPrincipal[0].description}
                           className="mentoria-propositos-container__icon"
                        ></img>
                        <h3
                           className="mentoria-propositos-container__title"
                        >
                           {cards.imagenPrincipal[0].description}
                        </h3>
                        <p>
                           Comencemos con tus sueños y metas... <br />¡Cuéntanos qué quieres alcanzar! Pueden ser propósitos individuales o familiares.
                        </p>
                        <Button
                           type="button"
                           classname="mentoria-propositos-container__button"
                           text={"Seleccionar propósitos"}
                           isDisabled={false}
                           onClickAction={handleSeleccionarPropositos}
                        />
                     </div>
                  );
               case 1:
                  return (
                     <div className="propositos-questions-container">
                        {
                           showQuestions && propositosQuestions ?
                              (
                                 <MentoriaQuestionWizard
                                    questions={propositosQuestions}
                                    formData={questionsData}
                                    setData={setData}
                                    onMoveAfterFallback={nextFallback}
                                    onMovePreviousFallback={prevFallback}
                                 />
                              ) :
                              <>
                                 <MultipleSelectCards
                                    selected={selected}
                                    setSelected={setSelected}
                                    cards={displayCards.slice(3)}
                                    disabled={showQuestions}
                                    limit={3}
                                 />
                                 <Button
                                    type="button"
                                    classname="propositos-questions-container__button"
                                    text={showQuestions ? "Guardar" : "Continuar"}
                                    isDisabled={false}
                                    onClickAction={showQuestions ? handlePropositosSave : handlePropositosContinue}
                                 />
                              </>
                        }
                     </div>
                  );
               case 2:
                  return (
                     <div className="propositos-questions-display">
                        <MultipleSelectCards
                           selected={selected}
                           setSelected={setSelected}
                           cards={displayCards.slice(3)}
                           limit={3}
                           disabled={true}
                           onlyShowSelected={true}
                        />
                        <Button
                           type="button"
                           classname="propositos-questions-display__button"
                           text="Ir a diagnóstico financiero"
                           isDisabled={false}
                           onClickAction={() => saveResponses()}
                        />
                     </div>
                  );
               default:
                  return null;
            }
         })()}
      </div>
   );
};

export default MentoriaPropositos;
